<script lang="ts">
import type { StudyPipelineSnapshotRow } from '$lib/components/study/slide-layout-types'

/** Three-column pipeline snapshot table; `snapshotHtml` is trusted `{@html}` in cells. */
interface Props {
  headers?: readonly [string, string, string]
  rows: readonly StudyPipelineSnapshotRow[]
  wrapStyle?: string
  tableStyle?: string
}

let {
  headers = ['Company', 'Program', 'Snapshot'],
  rows,
  wrapStyle = 'overflow-x:auto;width:100%;',
  tableStyle = 'width:100%;border-collapse:collapse;font-size:.76rem;line-height:1.42;',
}: Props = $props()

const thStyle =
  'text-align:left;padding:.38rem .5rem;border-bottom:1px solid var(--gbr);color:var(--mu);font-weight:600;'
const tdStyle = 'padding:.36rem .5rem;vertical-align:top;'
</script>

<div style={wrapStyle}>
  <table style={tableStyle}>
    <thead>
      <tr>
        <th style={thStyle}>{headers[0]}</th>
        <th style={thStyle}>{headers[1]}</th>
        <th style={thStyle}>{headers[2]}</th>
      </tr>
    </thead>
    <tbody>
      {#each rows as r}
        <tr>
          <td style={tdStyle}>{r.company}</td>
          <td style={tdStyle}>{r.program}</td>
          <td style={tdStyle}>{@html r.snapshotHtml}</td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>
